import react, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateProduct.scss";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const CreateProduct = () => {
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const raerAcess = localStorage.getItem("raerAcess");
  useEffect(() => {
    console.log({ raerAcess, tokena });
    if (raerAcess !== "1" || !tokena) {
      navigate("/login");
      return;
    }
  });

  const [dropdown, setDropdown] = useState([]);

  useEffect(() => {
    getCategoryList();
  }, []);

  const onChangeInputHandler = (e) => {
    const { name, value } = e.target;
    setInputHandler({ ...inputHandler, [name]: value });
  };

  const onDropdownChangeInputHandler = (e) => {
    const { name, value } = e.target;
    setInputHandler({ ...inputHandler, [name]: value });
  };

  const handleSizeDetailsChange = (index, e) => {
    const { name, value } = e.target;
    const newSizeDetails = [...inputHandler.sizeDetails];
    newSizeDetails[index] = { ...newSizeDetails[index], [name]: value };
    setInputHandler({ ...inputHandler, sizeDetails: newSizeDetails });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setInputHandler({ ...inputHandler, images: files });
  };

  const addSizeDetail = () => {
    setInputHandler({
      ...inputHandler,
      sizeDetails: [...inputHandler.sizeDetails, { size: "", stockCount: "" }],
    });
  };

  const [inputHandler, setInputHandler] = useState({
    productName: "",
    price: "",
    description: [],
    discount: "",
    categoryId: "",
    color: "",
    type: "",
    season: "",
    images: [],
    sizeDetails: [
      {
        size: "",
        stockCount: "",
        sku: "",
      },
    ],
  });

  const [urls, setUrl] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    e.preventDefault();

    const formData = new FormData();
    inputHandler.images.forEach((image, index) => {
      formData.append("images", image); // Change here to 'images' (plural)
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response?.data);
      // setUrl(response?.data?.urls);
      if (response?.data?.success) {
        setUrl(response?.data?.urls);
      } else {
        // toast.error("Opp!! Somthing Wrong Please Try Again", {
        //   position: "bottom-right",
        //   autoClose: 4000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "light",
        // });
        return;
      }
    } catch (error) {
      console.error(error);
    }
    console.log(urls);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/createProduct`,
      method: "post",
      data: { inputHandler, imgUrl: urls },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        if (response?.data?.status) {
          console.log(response?.data);
          // setDropdown(response?.data?.data);
          toast.success("Product Added Successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const getCategoryList = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `category/getAllCategories`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          setDropdown(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  return (
    <div className="createProduct">
      <section>
        <div className="form_data">
          <div
            className="cross"
            onClick={() => {
              navigate("/dashboard");
              window.scrollTo(0, 0);
            }}
          >
            <i className="bi bi-file-x-fill"></i>
          </div>
          <div className="form_heading">
            <h1>Create Product</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form_input">
              <label htmlFor="productName">Product Name</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.productName}
                id="productName"
                name="productName"
                placeholder="Product Name"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="price">Price</label>
              <input
                type="number"
                onChange={onChangeInputHandler}
                value={inputHandler.price}
                id="price"
                name="price"
                placeholder="Price"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="description">Description</label>
              <textarea
                style={{ width: "100%" }}
                rows={10}
                onChange={(e) => {
                  const descriptions = e.target.value.split("\n");
                  setInputHandler({
                    ...inputHandler,
                    description: descriptions,
                  });
                }}
                value={inputHandler.description.join("\n")}
                id="description"
                name="description"
                placeholder="Description (Separate multiple descriptions with new lines)"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="discount">Discount</label>
              <input
                type="number"
                onChange={onChangeInputHandler}
                value={inputHandler.discount}
                id="discount"
                name="discount"
                placeholder="Discount"
              />
            </div>
            <div className="form_input">
              <label htmlFor="categoryId">Category</label>
              <select
                onChange={onDropdownChangeInputHandler}
                desc
                name="categoryId"
                style={{
                  width: "20rem",
                  height: "2rem",
                  marginBottom: "1rem",
                }}
                required
              >
                <option value="">Select the Category</option>
                {dropdown?.map((item) => (
                  <option key={item?._id} value={item._id}>
                    {item.categoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className="form_input">
              <label htmlFor="productName">Product Type</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.type}
                id="type"
                name="type"
                placeholder="Product Type"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="productName">Product Season</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.season}
                id="season"
                name="season"
                placeholder="Product Season"
                required
              />
            </div>
            <div className="form_input">
              <label htmlFor="color">Color</label>
              <input
                type="text"
                onChange={onChangeInputHandler}
                value={inputHandler.color}
                id="color"
                name="color"
                placeholder="Color"
                required
              />
              <label htmlFor="images">Images</label>
              <input
                type="file"
                multiple
                onChange={handleImageChange}
                id="images"
                name="images"
                required
              />
              <div className="image-previews">
                {inputHandler.images.length > 0 &&
                  inputHandler.images.map((file, i) => (
                    <img
                      key={i}
                      src={URL.createObjectURL(file)}
                      alt={`preview ${i}`}
                      className="image-preview"
                    />
                  ))}
              </div>
              {inputHandler.sizeDetails.map((sizeDetail, sizeIndex) => (
                <div key={sizeIndex}>
                  <label htmlFor={`size_${sizeIndex}`}>Size</label>
                  <input
                    type="text"
                    onChange={(e) => handleSizeDetailsChange(sizeIndex, e)}
                    value={sizeDetail.size}
                    id={`size_${sizeIndex}`}
                    name="size"
                    placeholder="Size"
                    required
                  />
                  <label htmlFor={`stockCount_${sizeIndex}`}>Stock Count</label>
                  <input
                    type="number"
                    onChange={(e) => handleSizeDetailsChange(sizeIndex, e)}
                    value={sizeDetail.stockCount}
                    id={`stockCount_${sizeIndex}`}
                    name="stockCount"
                    placeholder="Stock Count"
                    required
                  />
                  <label htmlFor={`sku_${sizeIndex}`}>SKU</label>
                  <input
                    type="text"
                    onChange={(e) => handleSizeDetailsChange(sizeIndex, e)}
                    value={sizeDetail.sku}
                    id={`sku_${sizeIndex}`}
                    name="sku"
                    placeholder="SKU"
                    required
                  />
                </div>
              ))}
              <button type="button" onClick={addSizeDetail}>
                Add Size Detail
              </button>
            </div>
            <button type="submit" className="btn">
              Create Product
            </button>
          </form>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default CreateProduct;
